export default function () {

    var width = 750;
    var dw = document.documentElement.clientWidth;
    var _zoom = dw / width * 100;
    _zoom = _zoom > 70 ? 70 : _zoom;
    document.getElementsByTagName('html')[0].style.fontSize = _zoom + "px";
}